//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Positioning.js";
import "../Positioning/Positioning.Positioner.js";
let d=[[[0,"DisplayConstraints",1,0],[0,"DisplaySuppressedConstraints",1,0],[0,"MoveDumbGeometry",1,0],[0,"PrimaryArrangement",1,"Assemblies.Arrangement",0]],[[[],"BeginMoveComponent",{},0,0],[[],"EndMoveComponent",{},0,0],[[],"BeginAssemblyConstraints",{},0,0],[[],"EndAssemblyConstraints",{},0,0],[[],"BeginMoveComponentInWorkset",{},0,0],[[],"EndMoveComponentInWorkset",{},0,0],[["constraints"],"LoadConstraintGeometry",{},1,0],[[],"SolvePostponedConstraints",{},0,0],[[],"EstablishShapeChangeNetwork",{R_:{network:"Positioning.Network"}},0,0]],[]];
SPLM.Positioning.ComponentPositioner = class extends SPLM.Positioning.Positioner{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Positioning.ComponentPositioner";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;